:host {

  li {
    padding: var(--lgr-spacing-nano) 0 var(--lgr-spacing-nano) var(--lgr-spacing-xxxs);
    list-style: none;
    cursor: pointer;
    text-align: start;
    line-height: 1.5;

    &.lgr-suboption {
      padding: 0 0 0 var(--lgr-spacing-xs);
    }
  }

  .selected {
    background-color: var(--lgr-color-neutral-high-medium);
  }

  .disabled {
    color: var(--lgr-color-neutral-high-medium);
  }

  .padding-left-xxxl {
    padding-left: var(--lgr-spacing-md);
  }
}